/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { SelectAssessmentItemValues } from './selectAssessmentItemModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'select-assessment-item-modal',
    standalone: false,
})
export class SelectAssessmentItemModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Input() resolve: SelectAssessmentItemValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('selectAssessmentItemModal', elementRef, injector);
    }
}
